// ─── Event Viewer Templates ────────────────────────────────────────
//
// The starter kits offered on the AI Producer page (pages/dashboard/StarterKitsSection.tsx): metadata only. Choosing
// one fills the producer's prompt; the destination runtime builds the page. The template components these once
// described were never routed and were removed. The market is endurance sport only.

// Template metadata for starter kit selection
export interface TemplateMetadata {
  id: string;
  name: string;
  description: string;
  category: 'sports' | 'entertainment' | 'corporate';
  features: string[];
}

export const TEMPLATE_CATALOG: TemplateMetadata[] = [
  {
    id: 'ultra-running',
    name: 'Ultra Running',
    description: '100-mile endurance race template with GPS tracking, elevation profile, and aid stations',
    category: 'sports',
    features: [
      'Live GPS Map',
      'Custom Elevation Profile',
      'Men/Women Leaderboards',
      'Aid Station Tracker',
      'Athlete Cards',
      'Race Statistics',
      'Live Chat',
    ],
  },
];
